import { SignaturePadModule } from 'angular2-signaturepad';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header.component';
import { FooterComponent } from './layout/fotter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from './core/services/api.service';
import { JwtService } from './core/services/jwt.service';
import { AuthGuard } from './core/services/auth-guard.service';
import { SharedModule } from './core/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { SimpleGlobal } from 'ng2-simple-global';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JasperoConfirmationsModule } from '@jaspero/ng2-confirmations';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SidebarComponent } from './layout/sidebar.component';
import { BrowserXhr, HttpModule } from '@angular/http';
import { NgProgressBrowserXhr, NgProgressModule } from 'ngx-progressbar';
import { SearchModule } from "./core/search/search.module";
import { EmployeeModule } from "./employee/employee.module";
import { LoginModule } from "./login/login.module";
import { LotModule } from "./lot/lot.module";
import { CommonService } from "./core/services/common.service";
import { FormModule } from "./form/form.module";
import { AccessDeniedComponent } from "./common/access-denied/access-denied.component";
import { UserService } from "./core/services/user.service";
import { OcrComponent } from './ocr/ocr.component';
import { OcrDocumentUploaderComponent } from './ocr/ocr-document-uploader/ocr-document-uploader.component';
import { OcrDocumentValidatorComponent } from './ocr/ocr-document-validator/ocr-document-validator.component';
import { OcrService } from './core/services/ocr.service';
import { OcrAutoverifyResultComponent } from './ocr/ocr-autoverify-result/ocr-autoverify-result.component';
import { OcrAddressComponent } from './ocr/ocr-address/ocr-address.component';
import { OcrSucessPageComponent } from './ocr/ocr-sucess-page/ocr-sucess-page.component';
import { SentryErrorHandler } from "./app.sentry-error-handler.service";
import { ZohoAuthenticatePageComponent } from './zoho/zoho-authenticate/zoho-authenticate-page.component';

const rootRouting: ModuleWithProviders = RouterModule.forRoot([], {useHash: true});

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        SidebarComponent,
        AccessDeniedComponent,
        OcrComponent,
        OcrDocumentUploaderComponent,
        OcrDocumentValidatorComponent,
        OcrAutoverifyResultComponent,
        OcrAddressComponent,
        OcrSucessPageComponent,
        ZohoAuthenticatePageComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SimpleNotificationsModule.forRoot(),
        RouterModule,
        rootRouting,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        AppRoutingModule,
        JasperoConfirmationsModule,
        SearchModule,
        BrowserModule,
        NgProgressModule,
        HttpModule,
        EmployeeModule,
        LoginModule,
        LotModule,
        FormModule,
        SignaturePadModule
    ],
    providers: [UserService, ApiService,
        JwtService,
        AuthGuard,
        SimpleGlobal,
        CommonService,
        OcrService,
        {provide: BrowserXhr, useClass: NgProgressBrowserXhr},
        { provide: ErrorHandler, useClass: SentryErrorHandler }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/app.module.ts